<template>
  <div class="login">
    <input type='text' class='phone' placeholder='请输入手机号' v-model='phone'>
    <i class="clear-phone" @click="phone=''"></i>
    <p class="tips" v-show="!phoneValidate">请输入正确的手机号</p>
    <input type='text' placeholder='验证码' class='code' v-model='code'>
     <button @click='getCode()' class="get-code" :disabled="phoneValidate && buttonText=='获取验证码' ? null : 'disabled'">{{buttonText}}</button>
    <p class="tips" v-show="!codeValidate">请输入正确的验证码</p>

    <button @click='login()' class="login-btn">登录</button>
  </div>
</template>
<style scoped lang="scss">
    @import "../utils.scss";

    .login {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100%;
      height: 100vh;
      width: 100%;
      box-sizing: border-box;
      background: url("../assets/pic.jpg") no-repeat;
      padding: px2rem(125px) px2rem(60px) px2rem(60px) px2rem(60px);
      background-size: cover;
    }


    .tips {
        @include font-dpr(12px);
        color: #F52013;
        line-height: 12px;
        margin: px2rem(10px) 0;
    }

    .clear-phone {
      display: inline-block;
      height: px2rem(18px);
      width: px2rem(18px);
      transform: translateY(-140%);
      margin-bottom: 8px;
      background: url("../assets/clear.png");
      background-size: contain;
      vertical-align: middle;
      float: right;
    }

    .get-code {
      background: rgba(255,255,255,.14);
      padding: 0 px2rem(10px);
      height: px2rem(26px);
      line-height: px2rem(26px);
      border-radius: px2rem(62px);
      color: rgba(255,255,255, .6);
      @include font-dpr(13px);
      transform: translateY(-130%);
      margin-bottom: 8px;
      border: 0;
      float: right;
    }
    .phone, .code {
      width: px2rem(255px);
      height: px2rem(36px);
      line-height: px2rem(36px);
      @include font-dpr(16px);
      background: transparent;
      color: white;
      opacity: .6;
      border: 0;
      border-bottom: 1px solid white;
    }

    .login-btn {
        width: px2rem(255px);
        height: px2rem(48px);
        background: #79BD50;
        box-shadow: 0 px2rem(-2px) px2rem(4px) 0 rgba(0,0,0,0.10);
        border-radius: px2rem(4px);
        @include font-dpr(18px);
        color: #FFFFFF;
        line-height: px2rem(48px);
        margin-top: px2rem(87px);
        border: 0px;
    }
</style>
<script>
import {checkMobile} from '../utils.js'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'hello',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      phone:'',
      code:'',
      buttonText: '获取验证码',
      phoneValidate: true,
      codeValidate: true,
    };
  },
  computed: {
    showTip() {
      return !checkMobile(this.phone);
    },
    ...mapGetters({
       config: 'config',
    }),
  },
  watch : {
     phone() {
             if ((/^1[3456789]\d{9}$/.test(this.phone))) {
                 this.phoneValidate = true;
             }else {
                 this.phoneValidate = false;
             }
     }
  },
  methods: {
    getCode() {
      if(!this.showTip) {
        this.$http.get(this.config.host + '/api/customer/code?phone=' + this.phone,).then(data => {
            console.log(data);
        });
      }
      let i = 60;
      this.buttonText = `${i}s重新获取`;
      let timer = setInterval(() => {
          if(i>0){
            i--;
            this.buttonText = `${i}s重新获取`;
          }else{
            clearInterval(timer);
            this.buttonText = '获取验证码';
          }
      },1000);
    },

    login() {
      this.$http.post(this.config.host + '/api/customer/login',{
           phone:this.phone,
           code:this.code
        }).then((res)=>{
            if(res.data.data.success){
              localStorage.setItem("roupoo-token", res.data.data.token)
              if (res.data.data.name) {
                this.$router.replace('/');
              } else {
                this.$router.push({ name: 'NameRegister', query: {phone: this.phone} });
              }
            }else {
              this.codeValidate = false;
            }
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// Login.vue?e4840760